import React, { useEffect } from 'react';
import css from './ProjectsList.module.css';
import { ClipboardIcon } from '@shared/Icons/ClipboardIcon';
import { PaginationButtons } from '@shared/Widgets/PaginationButtons/PaginationButtons';
import { ProjectListTable } from '@modules/BillOfMaterials/Components/BillOfMaterials/ProjectsList/ProjectListTable/ProjectListTable';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useProjectsListViewModel } from '@viewModels/ProjectsListViewModel/ProjectsListViewModel';
import { notifyErrorCustom } from '@shared/Widgets/ToastNotifications/ToastNotifications';
import { BasicLoader } from '@shared/Ui/Loaders/BasicLoader/BasicLoader';
import { ROUTES } from '@configs/AppRoutes';

const ProjectList: React.FC = () => {
    const {
        customProjects,
        fetchCustomProjectsList,
        isProjectsListLoading,
        error,
        setCurrentPage,
    } = useProjectsListViewModel();
    const [searchParams, setSearchParams] = useSearchParams();
    const page = Number(searchParams.get('page')) || 1;

    const handleChangePage = (newPage: number) => {
        setSearchParams({ page: newPage.toString() });
    };

    useEffect(() => {
        setCurrentPage(page);
        fetchCustomProjectsList(page);
    }, [page]);

    useEffect(() => {
        if (error) {
            notifyErrorCustom(error);
        }
    }, [error]);

    return (
        <section className={css.section}>
            <div className={css.header}>
                <span>Project list</span>
                <ClipboardIcon fill={'var(--color-interactive-primary)'} />
            </div>
            {isProjectsListLoading ? <BasicLoader /> : <ProjectListTable />}
            {customProjects && (
                <div className={css.pagination}>
                    <PaginationButtons
                        pagination={customProjects.pagination}
                        changePage={handleChangePage}
                    />
                </div>
            )}
        </section>
    );
};

export default ProjectList;
